export default {
  "zh-CN": {
    sitePage: {
      title: "选择您的位置与服务",
      asia: "亚洲",
      europe: "欧洲",
      oceania: "大洋洲",
      china_pr: "中国大陆",
      japan: "日本",
      malaysia: "马来西亚",
      singapore: "新加坡",
      uae: "阿联酋",
      bulgaria: "保加利亚",
      czech: "捷克",
      germany: "德国",
      latvia: "拉脱维亚",
      lithuania: "立陶宛",
      uk: "英国",
      australia: "澳大利亚",
      speedpak: "SpeedPAK",
      ebay_fulfillment: "eBay Fulfillment",
      orangepak: "Domestic"
    }
  },
  "en-US": {
    sitePage: {
      title: "Select Your Location & Service",
      asia: "Asia",
      europe: "Europe",
      oceania: "Oceania",
      china_pr: "China PR",
      japan: "Japan",
      malaysia: "Malaysia",
      singapore: "Singapore",
      uae: "United Arab Emirates",
      bulgaria: "Bulgaria",
      czech: "Czech",
      germany: "Germany",
      latvia: "Latvia",
      lithuania: "Lithuania",
      uk: "United Kingdom",
      australia: "Australia",
      speedpak: "SpeedPAK",
      ebay_fulfillment: "eBay Fulfillment",
      orangepak: "Domestic"
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/i18n/SitePage_local.js